<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" :style="headerStyle">
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="image-wrapper">
            <div class="brand">
              <h1 style="margin-top:100px" class="Size">
                Your Place Real Estate<br /><span style="color:#C1A360"
                  >Consultancy</span
                >
              </h1>
              <h6>Find your perfect place</h6>
              <router-link to="/contactus">
                <md-button
                  style="background-color: #C1A360 !important; font-size:16px !important; font-family: Noto Serif JP;"
                >
                  Request a call
                </md-button>
              </router-link>
              <p class="pStyle">Our Partnerships</p>
              <div style=" background:rgba(0,0,0,0.6);" class="row">
                <div class="md-layout-item">
                  <div class="col">
                    <img :src="partners[0].image" class="Headimg" />
                    <img :src="partners[1].image" class="Headimg" />
                    <img :src="partners[2].image" class="Headimg" />
                    <img :src="partners[3].image" class="Headimg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main ">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item">
              <div class="row">
                <div
                  class="col-md imgsec3"
                  style="margin-top:5px; height:500px;"
                >
                  <img src="@/assets/img/yourplace/photo.png" />
                </div>
                <div class="col-md paddi">
                  <h4
                    style="//styleName: H4;
font-family: Noto Serif JP;
font-size: 26px;
font-style: normal;
font-weight: 900;
line-height: 40px;
letter-spacing: 0em;
color:#C1A360;
text-align:left;
"
                  >
                    01
                  </h4>
                  <h1
                    style="//styleName: H1;
font-family: Noto Serif JP;
font-size: 37px;
font-style: normal;
font-weight: 700;
line-height: 52px;
letter-spacing: 0em;
text-align: left;
"
                  >
                    Who we are
                  </h1>
                  <p style="text-align:left; font-size:16px;">
                    Your Place is one of the leading real estate brokerage<br />
                    companies in Egypt with over 14 years of solid experience in
                    Real Estate.<br />
                    Our mission is to be the most successful real estate firm in
                    Egypt. <br />Our vision is to achieve the highest possible
                    standards of the real estate market.
                  </p>
                </div>
                <div class="col-md"></div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar row">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised  img-fluid"
                  />
                  <h3 style="text-align:center;">01</h3>
                </div>
                
              </div>
            </div>
          </div>
       
          
        </div> -->
      </div>
      <div class="section sectionWhychooseus">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item">
              <img
                style="    position: absolute;
    height: 410px;
    width: 549px;
    left: -180px;
    /* top: 1540px; */
    float: left;
    border-radius: 0px;"
                src="../assets/img/yourplace/bg left.png"
              />
              <div class="center">
                <h4
                  style="//styleName: H4;
font-family: Noto Serif JP;
font-size: 26px;
font-style: normal;
font-weight: 900;
line-height: 40px;
letter-spacing: 0em;
color:#C1A360;
text-align:center;
"
                >
                  02
                </h4>
                <h1
                  style="//styleName: H1;
font-family: Noto Serif JP;
font-size: 37px;
font-style: normal;
font-weight: 700;
line-height: 52px;
letter-spacing: 0em;
text-align: center;
"
                >
                  Why Choose <span style="color:#C1A360;">Us</span>
                </h1>
                <p style="text-align:center;font-size:16px;">
                  Our professional sales team are qualified and trained to Get
                  the best<br />
                  offers and opportunities in the real estate market that suits
                  our Client <br />
                  and budget. We are experts!!!
                </p>
                <div class="row row-cols-1 row-cols-md-3 g-4">
                  <div class="col" style="z-index: 1;">
                    <div class="card h-100">
                      <div>
                        <img
                          class="card-img-top imgchoice"
                          style="width: 80px;
  
height: 80px; position:"
                          src="../assets/img/yourplace/icon1.png"
                        />
                      </div>
                      <div class="card-body">
                        <h5 style="text-align:center;">REAL ESTATE PROPERTY</h5>

                        <p class="card-text" style="font-size:16px;">
                          Investing in properties is always the most profitable
                          and secured type among all investment channels.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col" style="margin-bottom: 10px; z-index: 1;">
                    <div class="card h-100">
                      <div>
                        <img
                          class="card-img-top imgchoice"
                          style="width: 80px;

height: 80px; position:"
                          src="../assets/img/yourplace/icon2.png"
                        />
                      </div>
                      <div class="card-body">
                        <h5 style="text-align:center;">RENTAL INCOME</h5>

                        <p class="card-text" style="font-size:16px;">
                          when you have a property, you can rent it and start
                          generating profit immediately and on a regular basis
                          where you can increase the rental yearly matching the
                          inflation rate.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col" style="    z-index: 1;">
                    <div class="card h-100">
                      <div>
                        <img
                          class="card-img-top imgchoice"
                          style="width: 80px; 
   
height: 80px; position:"
                          src="../assets/img/yourplace/icon3.png"
                        />
                      </div>
                      <div class="card-body">
                        <h5 style="text-align:center;">FUTURE RESALE</h5>

                        <p class="card-text" style="font-size:16px;">
                          The value of your property will keep increasing in a
                          rate higher than any bank can provide you.
                        </p>
                      </div>
                    </div>
                  </div>
                  <img
                    class="imgRight"
                    style="    
"
                    src="../assets/img/yourplace/bg right.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section section3">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item">
              <div class="">
                <h4
                  style="//styleName: H4;
font-family: Noto Serif JP;
font-size: 26px;
font-style: normal;
font-weight: 900;
line-height: 40px;
letter-spacing: 0em;
color:#C1A360;
text-align:left;
"
                >
                  03
                </h4>
                <h1
                  style="//styleName: H1;
font-family: Noto Serif JP;
font-size: 37px;
font-style: normal;
font-weight: 700;
line-height: 52px;
letter-spacing: 0em;
text-align: left;
"
                >
                  How it works
                </h1>
                <p style="text-align:left;">
                  We take you through the process from your first thought of
                  <br />buying your unit till signing your contract.
                </p>
                <div class="row">
                  <div class="col-md">
                    <div class="row">
                      <span
                        ><span class="circle">1</span
                        ><span
                          style="//styleName: Title;
font-family: Noto Serif JP;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
padding-bottom:0px;
"
                          >Step 1</span
                        ></span
                      >
                      <h6
                        style="//styleName: Body;
font-family: Noto Sans JP;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
margin-left: 43px;
flex-shrink:1;
"
                      >
                        We know your need and your budget
                      </h6>
                    </div>
                    <div class="row">
                      <span
                        ><span class="circle">2</span
                        ><span
                          style="//styleName: Title;
font-family: Noto Serif JP;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
padding-bottom:0px;
"
                          >Step 2</span
                        ></span
                      >
                      <h6
                        style="//styleName: Body;
font-family: Noto Sans JP;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
margin-left: 43px;
flex-shrink:1;
"
                      >
                        We get you offers from various trusted developers and
                        help you to choose the best for you
                      </h6>
                    </div>
                    <div class="row">
                      <span
                        ><span class="circle">3</span
                        ><span
                          style="//styleName: Title;
font-family: Noto Serif JP;
font-size: 16px;
font-style: normal;
font-weight: 700;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
padding-bottom:0px;
"
                          >Step 3</span
                        ></span
                      >
                      <h6
                        style="//styleName: Body;
font-family: Noto Sans JP;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 28px;
letter-spacing: 0em;
text-align: left;
margin-left: 43px;
flex-shrink:1;
"
                      >
                        We facilitate the contracting process between you and
                        the developer until you receive your contract signed
                      </h6>
                    </div>
                  </div>
                  <div class="col-md imgsec3" style="margin-top: -220px;">
                    <img
                      src="@/assets/img/yourplace/wiktor-karkocha-WA2uSCbTXkI-unsplash 1.png"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section sectionSeprate">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item">
              <div class="center">
                <h1
                  style="//styleName: H4;
font-family: Noto Serif JP;
font-size: 40px;
font-style: normal;
font-weight: 900;
line-height: 40px;
letter-spacing: 0em;
color:#fff;
text-align:center;
"
                >
                  Never miss an opportunity
                </h1>

                <h1
                  style="//styleName: Body;
font-family: Noto Sans JP;
font-size: 18px;
font-style: normal;
font-weight: 400;
line-height: 28px;
color:white;
letter-spacing: 0em;
text-align: center;
"
                >
                  Our professional sales team are qualified and trained to
                  <br />Get the best offers and opportunities in the real estate
                  market<br />
                  that suits our Client needs and budget.
                </h1>

                <div layout="row" layout-align="center center">
                  <h1 style="text-align: center;">
                    <router-link to="/contactus">
                      <md-button
                        style="box-shadow:none !important; background-color:#fff !important;color:#C1A360 !important; border:1px solid #C1A360 !important; align:center; margin-top:20px"
                        class=""
                        >Request a call<img
                          style="height: 14.001276969909668px;
width: 16px;
left: 4px;
top: 5px;
border-radius: 0px;
"
                          src="../assets/img/yourplace/arrow.png"
                        />
                      </md-button>
                    </router-link>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section ">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item">
              <div class="">
                <h4
                  style="//styleName: H4;
font-family: Noto Serif JP;
font-size: 26px;
font-style: normal;
font-weight: 900;
line-height: 40px;
letter-spacing: 0em;
color:#C1A360;
text-align:center;
"
                >
                  04
                </h4>
                <h1
                  style="//styleName: H1;
font-family: Noto Serif JP;
font-size: 37px;
font-style: normal;
font-weight: 700;
line-height: 52px;
letter-spacing: 0em;
text-align: center;
"
                >
                  Let's explore the property
                  <br />
                  of <span style="color:#C1A360;">your dreams</span>
                </h1>
                <!-- <h6 style="text-align: center;">My dad once told me, laugh and the world laughs with you, Cry, and I'll <br>give you something to cry about you little bastard! They.</h6> -->
                <div class="row row-cols-1 row-cols-md-3 g-4">
                  <div
                    class="col flip-card"
                    style="margin-top:20px;margin-bottom:20px;"
                  >
                    <div class="card h-100 flip-card-inner">
                      <div class="flip-card-front">
                        <img
                          src="../assets/img/yourplace/Picture1.png"
                          class="card-img-top card-height"
                          alt="..."
                        />
                      </div>
                      <div class="flip-card-back">
                        <h1 class="fonth1">New Cairo City</h1>
                        <p>
                          is an Egyptian city covering an area of about 30,000
                          hectares on the southeastern edge of Cairo
                          Governorate, <br />
                          25 kilometers from Maadi.
                        </p>

                        <b-button
                          style="box-shadow:none !important; background-color:#fff !important;color:#C1A360 !important; border:1px solid #C1A360 !important; align:center; "
                          v-b-modal.modal-1
                          >Learn more</b-button
                        >

                        <b-modal
                          hide-footer="true"
                          id="modal-1"
                          title="New Cairo City"
                        >
                          <img
                            src="../assets/img/yourplace/Picture1.png"
                            class="card-img-top card-height"
                            alt="..."
                          />

                          <p>
                            New Cairo is an Egyptian city covering an area of
                            about 30,000 hectares on the southeastern edge of
                            Cairo Governorate, 25 kilometers from Maadi.<br />
                            New Cairo is one of the new cities which have been
                            built in and around Cairo to alleviate the
                            congestion in downtown Cairo.
                          </p>
                        </b-modal>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col flip-card"
                    style="margin-top:20px;margin-bottom:20px;"
                  >
                    <div class="card h-100 flip-card-inner">
                      <div class="flip-card-front">
                        <img
                          src="../assets/img/yourplace/Picture2.jpg"
                          class="card-img-top card-height"
                          alt="..."
                        />
                      </div>
                      <div class="flip-card-back">
                        <h1 class="fonth1">Ain Sokhna</h1>
                        <p>
                          Is a town in the Suez Governorate <br />lying on the
                          western shore of the Red Sea's Gulf of Suez
                        </p>
                        <b-button
                          style="box-shadow:none !important; background-color:#fff !important;color:#C1A360 !important; border:1px solid #C1A360 !important; align:center; "
                          v-b-modal.modal-2
                          >Learn more</b-button
                        >

                        <b-modal
                          hide-footer="true"
                          id="modal-2"
                          title="Ain Sokhna"
                        >
                          <img
                            src="../assets/img/yourplace/Picture2.jpg"
                            class="card-img-top card-height"
                            alt="..."
                          />
                          <p class="my-4">
                            Is a town in the Suez Governorate, lying on the
                            western shore of the Red Sea's Gulf of Suez. <br />
                            It is situated 55 kilometers (34 mi) south of Suez
                            and approximately 120 kilometers (75 mi) east of
                            Cairo.
                          </p>
                        </b-modal>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col flip-card"
                    style="margin-top:20px;margin-bottom:20px;"
                  >
                    <div class="card h-100 flip-card-inner">
                      <div class="flip-card-front">
                        <img
                          src="../assets/img/yourplace/Picture3.png"
                          class="card-img-top card-height"
                          alt="..."
                        />
                      </div>
                      <div class="flip-card-back">
                        <h1 class="fonth1">El Galala City</h1>
                        <p>
                          Galala City is considered as one of the largest
                          Egyptian development projects,<br />
                          with a unique tourist-attractive location,<br />
                          virgin beaches and a high altitude that gives the city
                          the climatic advantage of a temperature drop below sea
                          level of 10 degrees.
                        </p>
                        <b-button
                          style="box-shadow:none !important; background-color:#fff !important;color:#C1A360 !important; border:1px solid #C1A360 !important; align:center; "
                          v-b-modal.modal-3
                          >Learn more</b-button
                        >

                        <b-modal
                          hide-footer="true"
                          id="modal-3"
                          title="El Galala City"
                        >
                          <img
                            src="../assets/img/yourplace/Picture3.png"
                            class="card-img-top card-height"
                            alt="..."
                          />
                          <p class="my-4">
                            Galala City is considered as one of the largest
                            Egyptian development projects, with a unique
                            tourist-attractive location, virgin beaches and a
                            high altitude that gives the city the climatic
                            advantage of a temperature drop below sea level of
                            10 degrees.<br />
                            It has already attracted investments of more than
                            US$ 100 million in the last two years.<br />
                            The City is located on the highest mountain plateau
                            between Ain Sukhna and Zafarana and overlooks the
                            Red Sea coast.<br />
                            It lies approximately 170 kilometers away from the
                            Cairo International Airport and 50 kilometers away
                            from Port Sokhna.<br />

                            Galal City is home to a world-class medical city,
                            the first Olympic village for sports events and some
                            residential and tourist areas.<br />
                            Flagship investments in the area also include the
                            King Salman University and a tourist resort
                            overlooking the Gulf of Suez, the Global Galala
                            Tourism Resort.<br />
                            Construction work on the Galala Tourism Resort began
                            in 2015. It is located on the shore of the Gulf of
                            Suez in the area of "Ras Abu Daraj" on an area of
                            100 acres. <br />
                            The resort includes two hotels, one of which is
                            mountainous and coastal, with 300 rooms and 40
                            chalets, while the coastal area includes 300 rooms
                            and 60 chalets. <br />
                            A world-class resort, it features a marina for
                            yachts, with 239 yachts, fully equipped, and a city
                            of water games carried out by major international
                            companies.<br />
                            A 6-kilometer cable car, designed and supervised by
                            a French company, is currently being built to link
                            the tourist area with the medical city.<br />
                            It is considered the largest cable car project in
                            the MENA region. The Galala area is rich in natural
                            resources, and development projects are underway to
                            support investment opportunities in mining and
                            construction material industries, such as the road
                            that cuts into the mountains to facilitate the
                            transportation of raw materials for manufacture.<br />

                            A desalination plant with a capacity of 150 thousand
                            cubic meters is under construction to serve the
                            city.<br />
                            In addition, a road is being developed to connect
                            the city through different routes, and it starts
                            from the south of Port Said till the 92nd km on the
                            Ismailia Desert Road, then cuts the Suez and Ain
                            Sokhna Road in the Wadi Hjul area.<br />
                            There are plans to complete the road from the south
                            to reach the west of Hurghada and west of Safaga and
                            then "Abu Ramad" and Halaib and Shalatin up to the
                            area "Perforkit" on the international border with
                            Sudan. <br />
                            In addition, a 13-kilometer-long emergency link will
                            connect the coastal road with the main road.
                          </p>
                        </b-modal>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col flip-card"
                    style="margin-top:20px;margin-bottom:20px;"
                  >
                    <div class="card h-100 flip-card-inner">
                      <div class="flip-card-front">
                        <img
                          src="../assets/img/yourplace/Picture5.jpg"
                          class="card-img-top card-height"
                          alt="..."
                        />
                      </div>
                      <div class="flip-card-back">
                        <h1 class="fonth1">New Alamein</h1>
                        <p>
                          is a new city in northwest Egypt inaugurated by
                          Egyptian President Abdel Fattah el-Sisi on 1 March
                          2018.<br />
                          New Alamein lies on the Mediterranean Sea,<br />
                          approximately 85 km west of Borg El Arab International
                          Airport.
                        </p>
                        <b-button
                          style="box-shadow:none !important; background-color:#fff !important;color:#C1A360 !important; border:1px solid #C1A360 !important; align:center; "
                          v-b-modal.modal-4
                          >Learn more</b-button
                        >

                        <b-modal
                          hide-footer="true"
                          id="modal-4"
                          title="New Alamein"
                        >
                          <img
                            src="../assets/img/yourplace/Picture5.jpg"
                            class="card-img-top card-height"
                            alt="..."
                          />
                          <p class="my-4">
                            New Alamein, is a new city in northwest Egypt
                            inaugurated by Egyptian President Abdel Fattah
                            el-Sisi on 1 March 2018. <br />
                            New Alamein lies on the Mediterranean Sea,
                            approximately 85 km west of Borg El Arab
                            International Airport. <br />
                            Still under construction, New Alamein was conceived
                            by the Egyptian government as a center for tourism,
                            education, and government. <br />
                            The city has its own presidential palace and
                            ministry building. <br />
                            Construction is ongoing at New Alamein for three
                            universities, fifteen skyscrapers and high rise
                            towers, and 10,000 hotel rooms. Work has begun on
                            Phase II of the New Alamein megaproject, which
                            includes ten additional coastal towers.
                          </p>
                        </b-modal>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col flip-card"
                    style="margin-top:20px;margin-bottom:20px;"
                  >
                    <div class="card h-100 flip-card-inner">
                      <div class="flip-card-front">
                        <img
                          src="../assets/img/yourplace/Picture6.jpg"
                          class="card-img-top card-height"
                          alt="..."
                        />
                      </div>
                      <div class="flip-card-back">
                        <h1 class="fonth1">Egypt New Capital</h1>
                        <p>
                          The new city is to be located 45 kilometers (28 miles)
                          east of Cairo and just outside the Second Greater
                          Cairo Ring Road,<br />
                          in a currently largely undeveloped area halfway to the
                          seaport city of Suez.
                        </p>
                        <b-button
                          style="box-shadow:none !important; background-color:#fff !important;color:#C1A360 !important; border:1px solid #C1A360 !important; align:center; "
                          v-b-modal.modal-5
                          >Learn more</b-button
                        >

                        <b-modal
                          hide-footer="true"
                          id="modal-5"
                          title="Egypt New Capital"
                        >
                          <img
                            src="../assets/img/yourplace/Picture6.jpg"
                            class="card-img-top card-height"
                            alt="..."
                          />
                          <p class="my-4">
                            The New Administrative Capital (NAC) is a
                            large-scale project of a new capital city in Egypt
                            that has been under construction since 2015.<br />
                            It was announced by the then Egyptian housing
                            minister Mostafa Madbouly at the Egypt Economic
                            Development Conference on 13 March 2015. <br />
                            The capital city is considered one of the programs
                            and projects for economic development, which is part
                            of a larger initiative called Egypt Vision 2030.
                            <br />

                            The new capital of Egypt is yet to be given a
                            name.<br />
                            A competition was launched on the new capital's
                            website to choose a new name and logo for the city,
                            noting that a jury of specialists were formed to
                            evaluate the proposals submitted to list and
                            determine the best among all the proposals.<br />
                            Though, no official results have yet been announced
                            by the Egyptian Government.<br />
                            The new city is to be located 45 kilometers (28
                            miles) east of Cairo and just outside the Second
                            Greater Cairo Ring Road, in a currently largely
                            undeveloped area halfway to the seaport city of
                            Suez.<br />
                            According to the plans, the city will become the new
                            administrative and financial capital of Egypt,
                            housing the main government departments and
                            ministries, as well as foreign embassies.<br />
                            On 700 square kilometres (270 sq mi) total area, it
                            would have a population of 6.5 million people,
                            though it is estimated that the figure could rise to
                            seven million. <br />
                            Officially, a major reason for the undertaking of
                            the project was to relieve congestion in Cairo,
                            which is already one of the world's most crowded
                            cities, with the population of Greater Cairo
                            expected to double in the next few decades. Cairo,
                            for comparison, has a population of nearly 20
                            million.
                          </p>
                        </b-modal>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col flip-card"
                    style="margin-top:20px;margin-bottom:20px;"
                  >
                    <div class="card h-100 flip-card-inner">
                      <div class="flip-card-front">
                        <img
                          src="../assets/img/yourplace/Picture7.png"
                          class="card-img-top card-height"
                          alt="..."
                        />
                      </div>
                      <div class="flip-card-back">
                        <h1 class="fonth1">6th of October Governorate</h1>
                        <p>
                          was split from the Giza Governorate on 17 April 2008.
                          <br />It was created through a presidential decree in
                          order to ease the burden placed on Giza,<br />
                          one of Egypt's most densely populated governorates.
                        </p>
                        <b-button
                          style="box-shadow:none !important; background-color:#fff !important;color:#C1A360 !important; border:1px solid #C1A360 !important; align:center; "
                          v-b-modal.modal-6
                          >Learn more</b-button
                        >

                        <b-modal
                          hide-footer="true"
                          id="modal-6"
                          title="6th of October Governorate"
                        >
                          <img
                            src="../assets/img/yourplace/Picture7.png"
                            class="card-img-top card-height"
                            alt="..."
                          />
                          <p class="my-4">
                            The 6th of October Governorate was split from the
                            Giza Governorate on 17 April 2008. <br />
                            It was created through a presidential decree in
                            order to ease the burden placed on Giza, one of
                            Egypt's most densely populated governorates.<br />
                            The 6th of October City became the capital of the
                            6th of October Governorate, which was mostly made up
                            of recently established planned communities such as
                            the Sheikh Zayed City.<br />
                            On 14 April 2011, prime minister Essam Sharaf
                            dissolved the 6th of October Governorate and
                            reincorporated its territory into the Giza
                            Governorate. <br />
                            The governorate's name commemorates the Egyptian
                            military's successful crossing of the Suez Canal on
                            6 October 1973 during the October War. 6 October is
                            also Egypt's Armed Forces Day.
                          </p>
                        </b-modal>
                      </div>
                    </div>
                  </div>
                  <div class="col-md"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="section ">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item">
             
                <div class="">
                  
                  <h4 style="//styleName: H4;
font-family: Noto Serif JP;
font-size: 26px;
font-style: normal;
font-weight: 900;
line-height: 40px;
letter-spacing: 0em;
color:#C1A360;
text-align:center;
">05</h4>
<h1 style="//styleName: H1;
font-family: Noto Serif JP;
font-size: 37px;
font-style: normal;
font-weight: 700;
line-height: 52px;
letter-spacing: 0em;
text-align: center;
">
 What our customers say 
 <br>
<span style="color:#C1A360;">about us</span>
</h1>
<div style="alignment:center;">
  <div class="row justify-content-center">
  <div class="col-5" style="margin-top:20px;margin-bottom:20px;width:540px;height:315px;">
    <div class="card h-100">
     
      <div class="card-body"><span>
        <h5 class="card-title">Card title <img style="    padding-left: 270px;
    height: 30px;
"  src="@/assets/img/yourplace/Quote mark light.png" /></h5> </span>
        <p class="card-text">
          This is a longer card with supporting text below as a natural lead-in to
          additional content. This content is a little bit longer.
        </p>
      </div>
    </div>
  </div>
  
  <div class="col-5" style="margin-top:20px;margin-bottom:20px;">
    <div class="card h-100">
      
      <div class="card-body">
        <h5 class="card-title">Card title <img style="    padding-left: 270px;
    height: 30px;
"  src="@/assets/img/yourplace/Quote mark dark.png" /></h5>
        <p class="card-text">
          This is a longer card with supporting text below as a natural lead-in to
          additional content.
        </p>
      </div>
    </div>
  </div>
  </div>
   <div class="row justify-content-center">
  <div class="col-5" style="margin-top:20px;margin-bottom:20px;width:540px;height:315px;">
    <div class="card h-100">
     
      <div class="card-body"><span>
        <h5 class="card-title">Card title <img style="    padding-left: 270px;
    height: 30px;
"  src="@/assets/img/yourplace/Quote mark light.png" /></h5> </span>
        <p class="card-text">
          This is a longer card with supporting text below as a natural lead-in to
          additional content. This content is a little bit longer.
        </p>
      </div>
    </div>
  </div>
  
  <div class="col-5" style="margin-top:20px;margin-bottom:20px;">
    <div class="card h-100">
      
      <div class="card-body">
        <h5 class="card-title">Card title <img style="    padding-left: 270px;
    height: 30px;
"  src="@/assets/img/yourplace/Quote mark dark.png" /></h5>
        <p class="card-text">
          This is a longer card with supporting text below as a natural lead-in to
          additional content.
        </p>
      </div>
    </div>
  </div>
  </div>
</div>
                
              </div>
            </div>
          </div>
       
          
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "index",
  bodyClass: "profile-page",

  data() {
    return {
      partners: [
        { image: require("@/assets/img/yourplace/logotN 1.png") },
        { image: require("@/assets/img/yourplace/Group@3x 1.png") },
        { image: require("@/assets/img/yourplace/Emaar-1 1.png") },
        { image: require("@/assets/img/yourplace/pt-hydepark-logo 1.png") }
      ],
      tabPane1: [
        { image: require("@/assets/img/examples/studio-1.jpg") },
        { image: require("@/assets/img/examples/studio-2.jpg") },
        { image: require("@/assets/img/examples/studio-4.jpg") },
        { image: require("@/assets/img/examples/studio-5.jpg") }
      ],
      tabPane2: [
        { image: require("@/assets/img/examples/olu-eletu.jpg") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/cynthia-del-rio.jpg") },
        { image: require("@/assets/img/examples/mariya-georgieva.jpg") },
        { image: require("@/assets/img/examples/clem-onojegaw.jpg") }
      ],
      tabPane3: [
        { image: require("@/assets/img/examples/mariya-georgieva.jpg") },
        { image: require("@/assets/img/examples/studio-3.jpg") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/olu-eletu.jpg") },
        { image: require("@/assets/img/examples/studio-1.jpg") }
      ]
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/yourplace/header2.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/yourplace/photo.png")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.paddi {
  padding-left: 300px;
}
.modal {
  height: 500px !important;
}
.fonth1 {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-size: 1.9rem !important;
}
.flip-card {
  background-color: transparent;
  // width: 300px;
  height: 243px;

  perspective: 1000px;
}
.card-height {
  height: -webkit-fill-available;
  height: inherit;
}
.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  background-color: #bbb;
  color: black;
}

.flip-card-back {
  background-color: #c1a360 !important;
  color: white;
  transform: rotateY(180deg);
}
@media screen and (max-width: 600px) {
  .paddi {
    padding-left: 20px;
  }
  .profile-page .brand h1 {
    margin-top: 95px !important;
    font-size: 50px !important;
  }
  .sectionWhychooseus {
    background-image: url("../assets/img/yourplace/bg.png");
    height: 150vh !important;
  }
  .section3 {
    height: 190vh !important;
    margin-top: 100px;
  }
  .imgsec3 {
    margin-top: 215px !important;
  }
  .sectionSeprate {
    background-image: url("../assets/img/yourplace/slide0311.png");
    height: 312px;
    background-size: cover !important;
    background-repeat: no-repeat;
  }
  .imgRight {
    position: absolute;
    height: 410px;
    width: 549px;
    left: 0px !important;
    border-radius: 0px;
  }
}
.section {
  padding: 0;
}
.BheaderStyle {
  background-color: #c1a360 !important;
}
.sectionWhychooseus {
  background-image: url("../assets/img/yourplace/bg.png");
  height: 80vh;
}

.section3 {
  height: 120vh;
  margin-top: 100px;
}
.imgRight {
  position: absolute;
  height: 410px;
  width: 549px;
  left: 780px;
  border-radius: 0px;
}
.sectionSeprate {
  background-image: url("../assets/img/yourplace/slide0311.png");
  height: 312px;
  background-size: contain;
  background-repeat: no-repeat;
}
.card {
  border-style: none !important;
  border-bottom: 5px solid #c1a360 !important;
}
.imgchoice {
  margin-left: 40%;
  margin-top: 5%;
}
.pStyle {
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  margin-top: 60px;
}
.Headimg {
  width: 160px;
  height: 130px;
  padding: 40px;
}
span.circle {
  background: #c1a360 !important;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  color: black !important;
  display: inline-block;
  font-weight: bold;
  line-height: 40px;
  margin-right: 5px;
  text-align: center;

  width: 40px;
}
.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
